<!-- 发布活动 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">发布活动</p>
		</div>

		<div class="box">
			<img src="../assets/code.png" class="code-img">
			<span class="msg blue"><img src="../assets/icon-54.png" class="icon">电话： 15959447998</span>
			<span class="msg">邮箱：support@gyxqcdz.com</span>
			<button type="button" class="btn">联系我们</button>
		</div>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 74px 37px 37px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 0 14px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		padding: 40px 0 16px;
		box-sizing: border-box;
		margin-bottom: 30px;
	}

	.code-img {
		width: 200px;
		height: 200px;
		margin-bottom: 10px;
	}

	.msg {
		display: flex;
		align-items: center;
		color: #666666;
		font-size: 14px;
		margin-bottom: 2px;
	}

	.msg.blue {
		color: #2A63F3;
	}

	.btn {
		color: #FFFFFF;
		font-size: 16px;
		background-color: #2A63F3;
		border-radius: 100px;
		width: 155px;
		height: 38px;
		line-height: 38px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 10px;
	}

	.icon {
		width: 16px;
		margin-right: 2px;
	}
</style>
